module.exports = __webpack_public_path__ + "img/img14.daf59134.svg";